import {InquiryMultiField} from "./inquiry_multi_field";

export const MessageFieldConfig = {
    baseHtmlClass: 'inquiry_field--message',
    selector: '.inquiry_field--message'
}

export class MessageField extends InquiryMultiField {

    static new(inquiryForm) {
        if (!inquiryForm.element) { return null }
        const element = inquiryForm.element.querySelector(MessageFieldConfig.selector);
        if (element) { return new MessageField(element, inquiryForm) }
    }

    constructor(id_or_element, inquiryForm) {
        super(id_or_element, inquiryForm);
    }

    typecastValue(value) {
        if (value === '' || value === null) { return null }
        value = String(value);
        return value;
    }

    appendErrors() {
        if (this.isRequired() && !this.hasValue()) { this.errors.push(`${ this.label } can not be blank.`) }
    }

}